(() => {
  const sections = new Map(), rails = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function mountReveal(section) {
    if (sections.has(section) || !window.IntersectionObserver) return;
    const animations = new Set();
    let observer;
    function reset() {
      observer?.disconnect();
      animations.forEach(animation => animation.cancel());
      animations.clear();
      if (reduced.matches || window.Shopify?.designMode) return;
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          const target = entry.target;
          if (typeof target.animate !== 'function') return;
          const media = target.matches('picture,.sv-visual,.sv-card-image');
          const animation = target.animate(media ? [
            { transform: 'translateY(24px)', clipPath: 'inset(3% 0 3% 0)' },
            { transform: 'translateY(0)', clipPath: 'inset(0% 0 0% 0)' }
          ] : [
            { transform: 'translateY(20px)', opacity: .25 },
            { transform: 'translateY(0)', opacity: 1 }
          ], { duration: media ? 900 : 720, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'none' });
          animations.add(animation);
          animation.finished.then(() => animations.delete(animation)).catch(() => animations.delete(animation));
        });
      }, { threshold: .07, rootMargin: '0px 0px -24px 0px' });
      section.querySelectorAll('.sv-title,.sv-section-head>.sv-body,.sv-copy>.sv-body,.sv-card picture,.sv-visual,.sv-lookbook-head h2,.sv-lookbook-head p,.sv-journal .sv-card-image').forEach(target => observer.observe(target));
    }
    reduced.addEventListener('change', reset);
    reset();
    sections.set(section, () => { observer?.disconnect(); animations.forEach(animation => animation.cancel()); reduced.removeEventListener('change', reset); });
  }
  function mountRail(rail) {
    if (rails.has(rail) || rail.children.length < 2) return;
    const controls = document.createElement('div');
    controls.className = 'sv-rail-controls';
    const buttons = [-1, 1].map(direction => {
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', direction < 0 ? rail.dataset.previousLabel : rail.dataset.nextLabel);
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('aria-hidden', 'true');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', direction < 0 ? 'M20 12H4m6-6-6 6 6 6' : 'M4 12h16m-6-6 6 6-6 6');
      path.setAttribute('fill', 'none'); path.setAttribute('stroke', 'currentColor'); path.setAttribute('stroke-width', '1.5');
      svg.append(path); button.append(svg);
      button.addEventListener('click', () => move(direction));
      controls.append(button); return button;
    });
    rail.after(controls);
    function move(direction) {
      const step = rail.children[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).gap) || 18);
      rail.scrollBy({ left: direction * step, behavior: reduced.matches ? 'instant' : 'smooth' });
    }
    function update() {
      const max = rail.scrollWidth - rail.clientWidth;
      buttons[0].disabled = rail.scrollLeft < 3;
      buttons[1].disabled = rail.scrollLeft >= max - 3;
      controls.hidden = max < 3;
    }
    function keydown(event) {
      if (event.target !== rail || !['ArrowLeft', 'ArrowRight'].includes(event.key) || rail.scrollWidth <= rail.clientWidth) return;
      event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1);
    }
    rail.addEventListener('scroll', update, { passive: true });
    rail.addEventListener('keydown', keydown);
    const resize = window.ResizeObserver ? new ResizeObserver(update) : null;
    resize?.observe(rail);
    update();
    rails.set(rail, () => { resize?.disconnect(); rail.removeEventListener('scroll', update); rail.removeEventListener('keydown', keydown); controls.remove(); });
  }
  function scan(scope = document) {
    scope.querySelectorAll('.sv-section.sv-motion,.sv-lookbook[data-motion="true"]').forEach(mountReveal);
    scope.querySelectorAll('[data-sv-rail]').forEach(mountRail);
  }
  scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const map of [sections, rails]) for (const [root, cleanup] of map) if (event.target.contains(root)) { cleanup(); map.delete(root); }
  });
})();
